// extracted by mini-css-extract-plugin
export var date = "FeaturedPostsSlider-module--date--9911d";
export var excerpt = "FeaturedPostsSlider-module--excerpt--711aa";
export var imageContainer = "FeaturedPostsSlider-module--image-container--78292";
export var readMore = "FeaturedPostsSlider-module--read-more--34ff2";
export var slide = "FeaturedPostsSlider-module--slide--7d02b";
export var slider = "FeaturedPostsSlider-module--slider--74b8f";
export var title = "FeaturedPostsSlider-module--title--01767";